/**
 * Description: Review page for the Audit Tool.
 */
import React from 'react';
import {
  AppLayout,
  Input,
  FormSection,
  Select,
  Button,
  ColumnLayout,
  DatePicker,
  Cards,
  Badge
} from 'AWS-UI-Components-React';
import Moment from 'moment';
import '../styles/filterSection.css';
import { CustomNavigation } from './customNavigation.jsx';
import { JSClient } from './common.jsx';
import {AuditButton} from './auditButton';
import { ErrorMessage } from './filterErrorSection.jsx';
import { UI_DATE_FORMAT, MARKETPLACES } from './constants';

const AFTER_DATE_FORMAT = "YYYY-MM-DDT00:00:00.000ZZ";
const BEFORE_DATE_FORMAT = "YYYY-MM-DDT23:59:59.999ZZ";
const filter_labels = {
  after_date: "Start date (inclusive):",
  before_date: "End date (inclusive):",
  marketplace: "Marketplace:",
  button_text: "Get Metrics"
}

const card_definition = {
  header: item => item.username,
  sections: [
    {
      id: "Batches Audited between start and end dates",
      header: "Batches Audited between start and end dates",
      content: item => <Badge color="green" content={item.metric_count}></Badge>
    }
  ]
}

const cardsPerRow = [
  {
    "cards": 1
  },
  {
    "minWidth": 500,
    "cards": 2
  }
]

const today = new Date();
let todayDate = today.getDate();
let todayMonth = today.getMonth() + 1;
let todayYear = today.getFullYear();

const yesterday = new Date();
yesterday.setDate(today.getDate() - 1);
let yesterdayDate = yesterday.getDate();
let yesterdayMonth = yesterday.getMonth() + 1;
let yesterdayYear = yesterday.getFullYear();

export class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.browseSection = React.createRef();
    this.state = {
      initialLoadDone: false,
      user: null,
      filter_options: {
        after_date: Moment(yesterday).format(UI_DATE_FORMAT),
        before_date: Moment(today).format(UI_DATE_FORMAT),
        marketplace: "0"
      },
      get_user_metric_response: {
        metric_count: null,
        username: null
      },
      error: "",
      loading_metrics: false,
      is_invalid_date: false
    };
    this.errorMessage = React.createRef();
    this.filter_labels = filter_labels;
    this.handleFilterButtonClick = this.handleFilterButtonClick.bind(this);
    this.filterCallback = this.filterCallback.bind(this);
    this.clientLoaded = this.clientLoaded.bind(this);
  }

  getUserMetricsCallback(options) {
    return this.client.getUserMetrics(options,
      result => {
        this.setState((state, props) => {
          return ({
            loading_metrics: false,
            get_user_metric_response: result
          });
      })},
      error => {
        console.log(error);
        this.setState((state, props) => {
          return ({
            loading_metrics: false,
          });
        });
    })
  }

  filterCallback(common_options) {
    return this.getUserMetricsCallback(common_options);
  }


  handleFilterButtonClick() {
    // check filter options first

    if (this.state.is_invalid_date) {
      return null
    }
    if (this.state.filter_options.marketplace == "0") {
      alert("Please select a marketplace.");
      return null;
    }
    this.setState((state, props) => {
      return ({
        loading_metrics: true
      });
    });

    // modify filter options format
    var formatted_filters = {
        after_date: this.state.filter_options.after_date,
        before_date: this.state.filter_options.before_date,
        marketplace: this.state.filter_options.marketplace
    };
    if (this.state.filter_options.after_date.length > 0) {
      formatted_filters.after_date = Moment(this.state.filter_options.after_date).format(AFTER_DATE_FORMAT);
    }
    if (this.state.filter_options.before_date.length > 0) {
      formatted_filters.before_date = Moment(this.state.filter_options.before_date).format(BEFORE_DATE_FORMAT);
    }
    return this.filterCallback(formatted_filters);
  }

  clientLoaded() {
    this.client.getIdentity(identityResult => {
        this.setState((state, props) => {
          return ({
            user: identityResult.username,
            initialLoadDone: true
          });
        });
    });
  }

  componentWillMount() {
    require('./common.jsx');
    this.client = new JSClient({ onReady:
        this.clientLoaded
    });

  }

  render() {
    if (!this.state.initialLoadDone) {
      return (
        <center>
          <h1>Authorizing user please wait...</h1>
        </center>
      );
    }

    const FilterContent = () => (
      <div>
        <div><ErrorMessage ref={this.errorMessage}/></div>

        <div>{this.filter_labels.after_date}</div>
        <div><DatePicker
          todayLabel="Today"
          nextMonthLabel="Next month"
          previousMonthLabel="Previous month"
          value={this.state.filter_options.after_date}
          placeholder="YYYY/MM/DD"
          invalid={this.state.is_invalid_date}
          onChange={
            (event) => {
              this.state.filter_options.after_date = event.detail.value;
              this.state.is_invalid_date = this.errorMessage.current.checkFilterOptions(this.state.filter_options).length > 0;
            }
          }
        >
        </DatePicker></div>

        <div>{this.filter_labels.before_date}</div>
        <div><DatePicker
          todayLabel="Today"
          nextMonthLabel="Next month"
          previousMonthLabel="Previous month"
          value={this.state.filter_options.before_date}
          placeholder="YYYY/MM/DD"
          invalid={this.state.is_invalid_date}
          onChange={
            (event) => {
              this.state.filter_options.before_date = event.detail.value;
              this.state.is_invalid_date = this.errorMessage.current.checkFilterOptions(this.state.filter_options).length > 0;
            }
          }
        >
        </DatePicker></div>

        <div>{this.filter_labels.marketplace}</div>
        <div className="filter-options"><Select
          options={MARKETPLACES}
          enableFiltering={true}
          empty="No options"
          selectedId={this.state.filter_options.marketplace}
          placeholder="Select a marketplace"
          onChange={ (event) => {
            this.state.filter_options.marketplace = event.detail.selectedId;
          }
        }
        ></Select></div>

        <div><Button
          text={this.filter_labels.button_text}
          variant="primary"
          onClick={e => {this.handleFilterButtonClick();}}
        /></div>
      </div>
    )

    // check if there're metric response to decide whether to display card
    let items = [];
    if (this.state.get_user_metric_response.username) {
      items = [this.state.get_user_metric_response];
    }

    return (
      <div className="awsui">
        <AppLayout
          className='awsui-util-no-gutters'
          content={
            <div>
              <div className="awsui">
                <div>
                  <FormSection header="Metrics Date Range" expandable={true} expanded={true}>
                      <div data-awsui-column-layout-root="true" className="filter-options">
                        <div>
                          <div className="awsui">
                            <div>
                              <FilterContent/>
                            </div>
                          </div>
                        </div>
                        <div style={{fontWeight: "bold", fontSize: 20, textAlign: "center"}}>
                        </div>
                      </div>
                  </FormSection>

                  <Cards
                    cardDefinition={card_definition}
                    items={items}
                    cardsPerRow={cardsPerRow}
                    loadingText="Loading metrics"
                    loading={this.state.loading_metrics}
                    empty={<div className="awsui-util-t-c">
                      <b className="awsui-util-font-size-3">
                        Pick a desired marketplace and dates to view your metrics
                      </b>
                    </div>
                    }
                  ></Cards>

                </div>
              </div>
            </div>
          }
          navigation={<CustomNavigation />}
          toolsHide={true}
          navigationOpen={false}
        />
      </div>
    );

  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard.jsx